import { db } from "../../firebaseConfig";
export default {
  state: {
    menuItems: [],
    loading: false,
    error: null,
    openSentenceGameNumber: null,
    safeTop: 0,
    safeBottom: 0,
    isPlaying: false,
  },
  mutations: {
    setMenuItems(state, payload) {
      state.menuItems = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setError(state, payload) {
      state.error = payload;
    },
    clearError(state) {
      state.error = null;
    },
    openSentenceGameNumber(state, payload) {
      state.openSentenceGameNumber = payload;
    },
    setSafeTop(state, payload) {
      state.safeTop = payload;
    },
    setSafeBottom(state, payload) {
      state.safeBottom = payload;
    },
    setIsPlaying(state, payload) {
      state.isPlaying = payload;
    }
  },
  actions: {
    openSentenceGameNumber({ commit }, payload) {
      console.log({ payload });
      commit("openSentenceGameNumber", payload.number);
    },
    clearError({ commit }) {
      commit("clearError");
    },
    setError({ commit }, payload) {
      commit("setError", payload);
    },
    async getMenuItems({ commit }) {
      commit("setLoading", true);

      const menuBase = {
        course: [],
        wordGame: [],
        sentenceGame: []
      };

      const courseData = await db.collection("course-structure").get();
      courseData.forEach(async function(doc) {
        const newData = doc.data();
        menuBase.course.push(newData);
      });

      const wordGameData = await db.collection("words-categories").get();
      wordGameData.forEach(async function(doc) {
        const { id } = doc;
        const newData = doc.data();
        menuBase.wordGame.push({ ...newData, id });
      });

      commit("setMenuItems", menuBase);
      commit("setLoading", false);
    }
  },
  getters: {
    safeTop(state) {
      return state.safeTop;
    },
    safeBottom(state) {
      return state.safeBottom;
    },
    openSentenceGameNumber(state) {
      return state.openSentenceGameNumber;
    },
    loading(state) {
      return state.loading;
    },
    error(state) {
      return state.error;
    },
    menuItems(state) {
      return state.menuItems;
    },
    isPlaying(state) {
      return state.isPlaying;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/shared.store.js